@if (order) {
<rask-page [pageTitle]="order.leverantor">
    <ng-container header>
        <rask-action-button
            (click)="removeClick('LEVERANTORSORDER_DETAIL_DELETE_PROMPT_HEADER','LEVERANTORSORDER_DETAIL_DELETE_PROMPT_TEXT','leverantorsorder')"
            icon="far fa-trash-alt" aid="buttonRemove" [disabled]="!canEdit()">
            {{'DEFAULT_TA_BORT' | translate}}</rask-action-button>
        <rask-action-button [disabled]="!canEdit()" (click)="addOrderrad()" icon="fas fa-plus"
            aid="buttonAddOrderrad">
            {{'LEVERANTORSORDER_DETAIL_SKAPANYORDERRAD' | translate}}</rask-action-button>
        <rask-action-button (click)="copy()" icon="fas fa-plus" aid="buttonCopyKundorder">
            Kopiera leverantorsorder</rask-action-button>
    </ng-container>
    <ng-container headerContent>
        <rask-leverantorsorder-header [orderDetail]="order">
        </rask-leverantorsorder-header>
    </ng-container>
    <rask-toggle-list>
        <ng-container list-header>
            <rask-label size="3">{{'LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP' | translate}}</rask-label>
            <rask-label size="1">Avtals&shy;kvantitet</rask-label>
            <rask-label style="width:120px;max-width:none;">{{'LEVERANTORSORDER_DETAIL_ROW_MATTSLAG' |
                translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'DEFAULT_PERIODFROM' | translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'DEFAULT_PERIODTOM' | translate}}</rask-label>
            <rask-label>{{'LEVERANTORSORDER_EGEN_BEFRAKTNING' | translate}}</rask-label>
            <rask-label>{{'KUNDORDER_DETAIL_BALANS' | translate}}</rask-label>
        </ng-container>
        @for (orderrad of order?.leverantorsorderrader; track orderrad) {
        <rask-toggle-list-item
            [locked]="orderrad.id === 0"
            [expanded]="order.leverantorsorderrader.length === 1">
            <ng-container item-header>
                <rask-leverantorsorderrad-edit
                    [rootForm]="rootForm"
                    [showLabels]="false"
                    [order]="order"
                    (onRemove)="removeOrderrad(orderrad)"
                    [leverantorsorderrad]="orderrad">
                </rask-leverantorsorderrad-edit>
            </ng-container>
            <ng-template>
                @if (orderrad.id !== 0) {
                <rask-leverantorsorder-leveransrader
                    [canEdit]="canEdit()"
                    [orderrad]="orderrad">
                </rask-leverantorsorder-leveransrader>
                }
            </ng-template>

        </rask-toggle-list-item>
        }
    </rask-toggle-list>
    <ng-container footerContent>
        <rask-button aid="buttonAngra" color="tertiary" (click)="undo()" [disabled]="!commandService.isDirty()">
            {{ 'DEFAULT_UNDO_BUTTON_ANGRA' | translate }}</rask-button>
        <rask-save-button (click)="save()" [disabled]="!canSave()"></rask-save-button>
    </ng-container>
</rask-page>
}